import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn, signUp } from "../authService.ts";
import {
    Flex,
    Heading,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Box,
    Avatar,
    FormControl,
    Alert,
    CloseButton,
    AlertDescription,
    InputRightElement,
    Text,
    Spacer,
} from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";

import { FaUserAlt, FaLock } from "react-icons/fa";

const CFaUserAlt = chakra(FaUserAlt);
const CFaLock = chakra(FaLock);

const displayForgotPassword = () => {
    return (
        <Box display="flex" justifyContent="flex-end">
            <Text fontSize="12px">
                <ChakraLink as={ReactRouterLink} to="/forgotpassword">
                    Forgot your password?
                </ChakraLink>
            </Text>
        </Box>
    );
};

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isSignUp, setIsSignUp] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const handleShowClick = () => setShowPassword(!showPassword);

    const onCloseAlert = () => setErrorMessage(null);
    const showAlert = () => {
        return (
            <Alert status="error">
                <Box>
                    <AlertDescription>{errorMessage}</AlertDescription>
                </Box>
                <Spacer />
                <CloseButton
                    alignSelf="flex-start"
                    position="relative"
                    onClick={onCloseAlert}
                />
            </Alert>
        );
    };

    const handleSignIn = async (e) => {
        //e.preventDefault();
        //window.location.href = "/dashboard";
        //return;

        e.preventDefault();
        try {
            const session = await signIn(email, password);
            console.log("Sign in successful", session);
            if (session && typeof session.AccessToken !== "undefined") {
                sessionStorage.setItem("accessToken", session.AccessToken);
                if (sessionStorage.getItem("accessToken")) {
                    window.location.href = "/dashboard";
                } else {
                    console.error("Session token was not set properly.");
                }
            } else {
                console.error("SignIn session or AccessToken is undefined.");
            }
        } catch (error) {
            // alert(`Sign in failed: ${error}`);
            setErrorMessage("Sign in failed");
        }
    };

    const handleSignUp = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }
        try {
            await signUp(email, password);
            navigate("/confirm", { state: { email } });
        } catch (error) {
            setErrorMessage("Sign up failed");
            //  alert(`Sign up failed: ${error}`);
        }
    };

    return (
        <Flex
            flexDirection="column"
            width="100wh"
            height="100vh"
            backgroundColor="gray.200"
            justifyContent="center"
            alignItems="center"
        >
            <Stack
                flexDir="column"
                width="340px"
                minHeight="500px"
                pt="50px"
                pb="40px"
                justifyContent="center"
                alignItems="center"
                backgroundColor="whiteAlpha.900"
            >
                <Avatar bg="orange.500" />
                <Heading color="orange.400">Welcome</Heading>
                <Box mt="10" minW={{ base: "95%" }}>
                    <form>
                        <Stack spacing={4} p="1rem" backgroundColor="whiteAlpha.900">
                            {errorMessage != null ? showAlert() : ""}
                            <FormControl>
                                <InputGroup>
                                    <InputLeftElement
                                        pointerEvents="none"
                                        children={<CFaUserAlt color="gray.300" />}
                                    />
                                    <Input
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        placeholder="email address"
                                    />
                                </InputGroup>
                            </FormControl>
                            <FormControl>
                                <InputGroup>
                                    <InputLeftElement
                                        pointerEvents="none"
                                        color="gray.300"
                                        children={<CFaLock color="gray.300" />}
                                    />
                                    <Input
                                        onChange={(e) => setPassword(e.target.value)}
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        value={password}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                            {showPassword ? "Hide" : "Show"}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                            </FormControl>
                            {isSignUp && (
                                <FormControl>
                                    <InputGroup>
                                        <InputLeftElement
                                            pointerEvents="none"
                                            color="gray.300"
                                            children={<CFaLock color="gray.300" />}
                                        />
                                        <Input
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            type={showPassword ? "text" : "password"}
                                            placeholder="password"
                                            value={confirmPassword}
                                        />
                                        <InputRightElement width="4.5rem">
                                            <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                                {showPassword ? "Hide" : "Show"}
                                            </Button>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>
                            )}
                            {isSignUp ? "" : displayForgotPassword()}
                            <Button
                                borderRadius={0}
                                type="submit"
                                variant="solid"
                                colorScheme="orange"
                                width="full"
                                onClick={isSignUp ? handleSignUp : handleSignIn}
                            >
                                {isSignUp ? "Sign Up" : "Sign In"}
                            </Button>
                            <Button as="a" onClick={() => setIsSignUp(!isSignUp)}>
                                {isSignUp
                                    ? "Already have an account? Sign In"
                                    : "Need an account? Sign Up"}
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Stack>
        </Flex>
    );
};

export default LoginPage;